import axios from "axios";
import config from "@/config/apiurl";
import { Notification } from "element-ui";

/**
 * 实例化
 * config是库的默认值，然后是实例的 defaults 属性，最后是请求设置的 config 参数。后者将优先于前者
 */
axios.defaults.timeout = 3600;
axios.defaults.baseURL = config.ajaxUrl;

const http = axios.create({
  timeout: 1000 * 60,
  withCredentials: false, // 表示跨域请求时是否需要使用凭证
  headers: {
    "Content-Type": "application/json"
  }
});
function packParams(data) {
  if (!data) return {};
  const formData = new FormData();
  for (var key in data) {
    if (data[key] instanceof Array) {
      data[key].forEach((elem, index) => {
        if (typeof elem === "object") {
          for (const zkey in elem) {
            formData.append(`${key}[${index}].${zkey}`, elem[zkey]);
          }
        } else {
          formData.append(`${key}[${index}]`, elem);
        }
      });
    } else if (typeof data[key] === "object") {
      const obj = data[key];
      if (obj instanceof File) {
        formData.append(`${key}`, obj);
      } else {
        for (var pItem in obj) {
          formData.append(`${key}.${pItem}`, obj[pItem]);
        }
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  return formData;
}
/**
 * 请求拦截
 */
http.interceptors.request.use(
  config => {
    if (config.isFormData) {
      config.headers["Content-Type"] = "multipart/form-data";
      if (config.data) {
        config.data = packParams(config.data);
      }
    }
    let token = localStorage.getItem("liuyanToken");
    if (token) {
      config.headers["Authorization"] = token
    }

    // 只在user/space/getLis加 否则screen/index接口有跨域问题出现
    let token1 = sessionStorage.getItem("liuyanToken")
    const url = config.url
    const substring = "departed/information";
    const containsSubstring = url.includes(substring);
    if (token1 && containsSubstring) {
      config.headers["Authorization"] = token1
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截
 */
http.interceptors.response.use(
  async response => {

    if (response.data.code === 0) {
      return response.data.data;
    } else {
      Notification.closeAll();
      Notification.info({
        title: "提示",
        message: `${response.data.message}`
      });
      return Promise.reject(response.data);
    }
  },
  error => {
    console.log(error);
    Notification.closeAll();
    if(error.message=='Network Error'){
      Notification.info({
        title: "提示",
        message: '网络错误'
      });
    }else{
      Notification.info({
        title: "提示",
        message: `${error.message}`
      });
    }
    
    return Promise.reject(error);
  }
);
export default http;
